module.exports = __webpack_public_path__ + "static/media/sair.02dcd0b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/bottombar/sair.svg
// module id = ./src/statics/bottombar/sair.svg
// module chunks = 0